import React, { useState, useContext } from 'react'
import { formatDate, ROUTES } from '../../../shared/constants'
import CustomTableLayout from '../../../components/CustomComponents/CustomTableLayout'
import useDebounce from '../../../hooks/useDebounce'
import { useCheckinCheckout } from '../../../hooks/Features/useCheckinCheckout'
import { useChannelType } from '../../../hooks/CompanyConfiguration/useChannelType'
import { useSalesChannelType } from '../../../hooks/CompanyConfiguration/useSalesChannelType'
//? Material-ui
import { BeatPlanContext } from '../../../context api/BeatPlan/BeatPlanContext'
import { ConfigurationContext } from '../../../context api/Configuration/ConfigurationContext'

export default function CheckInCheckOutReport() {
  const startDate = new Date()
  const redirectUrl = 'GET_CHECKIN_CHECKOUT_REPORT'
  startDate.setDate(1)
  startDate.setHours(0, 0, 0)
  const [from, setFrom] = React.useState(startDate.toISOString())
  const [to, setTo] = React.useState(new Date().toISOString())
  //   const [channelType, setChannelType] = React.useState("");
  //   const [channelName, setChannelName] = React.useState("");
  const [searchQuery, setSearchQuery] = useState('')
  const debouncedValue = useDebounce(searchQuery, 500)
  //   const {getAllBeatPlan, deleteMany,BulkUploadBeatPlan, addBeatPlan, pdfCsvData} = UseBeatPlan();
  const { getCheckInCheckOutReport, pdfCsvData, log, downloadLoading, paginateData, getPdfCsvData } = useCheckinCheckout()
  //   const {beatPlans, loading, addNewBeatPlan} =useContext(BeatPlanContext)
  //   const { channelTypes, salesChannelTypes } = useContext(ConfigurationContext)
  //   const {getAllChannelType}  = useChannelType();
  //   const {"" getAllSalesChannelType } = useSalesChannelType()
  const [page, setPage] = React.useState(1)
  const [noOfPages, setNoOfPages] = React.useState(1)
  const limit = 10;
  // const noOfPages = 100;
  const [tmpArr, setTmpArr] = useState([]);


  const handlePageChange = (event, value) => {
    console.log("PAGE", value);
    setPage(value)
  }


//  React.useEffect(()=>{
//     getCheckInCheckOutReport({download: true});
//  },[])
  React.useEffect(() => {
    getCheckInCheckOutReport({ page: page, limit: limit, from, to });
    getPdfCsvData(redirectUrl, { page: page, limit: limit, from, to })
  }, [page, limit, from, to])

  React.useEffect(() => {

  }, [log, paginateData])

  const getOrNull = (e) => {
    return e ? e : "--";
  }
  React.useEffect(() => {
    let tmp = [];
    console.log("beat plans", log, paginateData)
    if (log.length === 0) setTmpArr([]);
    else if (log?.length > 0) {
      tmp = log?.map((item) => {
        return ([
          // { type: 'CHECKBOX', _id: item?._id },
          { value: getOrNull(item?.EmployeeId?.firstName + " " + item?.EmployeeId?.lastName) },
          { value: getOrNull(item?.EmployeeId?.reportingManager.firstName + " " + item?.EmployeeId?.reportingManager.lastName) },
          { value: getOrNull(item?.location[0]) },
          { value: getOrNull(item?.location[1]) },
          { value: getOrNull(item?.checkIn.checkInDate) },
          { value: getOrNull(item?.createdAt.substring(11, 16)) },
          { value: getOrNull(item?.checkOut?.checkOutDate) },
          { value: getOrNull(item?.checkOut?.checkOutTime) },
          { value: getOrNull(item?.checkIn?.channelType?.name) },
          { value: getOrNull(item?.checkIn?.channelName?.name) },
          { value: getOrNull(item?.checkIn?.channelName?.contact) },
          { value: getOrNull(item?.checkIn?.channelName?.address) },
        ])
      })
    }
    setTmpArr(tmp);
    setNoOfPages(paginateData?.totalPage)
  }, [log, paginateData])

  //   React.useEffect(() => {
  //     getAllChannelType()
  //     console.log("channelTypes====================>", channelTypes);
  //   }, [])

  //   React.useEffect(() => {
  //     if(channelType){
  //       getAllSalesChannelType({ page: 1, channelType: channelType})
  //     }
  //   }, [channelType])

  //   React.useEffect(() => {
  //     console.log(salesChannelTypes)
  //   }, [salesChannelTypes])
  const headers = ['Employee', 'TSM', 'Location lat', 'Location long', 'Checkin date', 'Checkin Time', 'checkoutdate', 'checkouttime', 'channel type', 'channel name', 'contact', 'address']

  const layoutProps = {
    heading: 'CheckIn CheckOut Report',
    searchQuery: searchQuery,
    setSearchQuery: setSearchQuery,
    permissionName: 'ATTENDANCE',

    filename: 'checkincheckout',
    sampleName: 'checkincheckout',
    // sheetName: 'beats',
    // addData: addNewBeatPlan,
    setPage,
    sheetName: 'checkincheckout',
    tempHeaders: {headers},
    downloadLoading: false,
    selectedFrom:from,
    setSelectedFrom:setFrom,
    selectedTo:to,
    setSelectedTo:setTo,
    //tempHeaderData :{[]},

    headers: pdfCsvData.headings,
    data: pdfCsvData.headingValues,
    // handleUploadFile: BulkUploadBeatPlan
  }

  return (
    <>

      <CustomTableLayout
        tableHeadings={headers}
        loading={false}
        tableBody={tmpArr}
        layoutProps={layoutProps}
        none
        headers={headers}
        paginate={{ totalPage: noOfPages, page: page }}
        // deleteMany={(val, setSelected) => deleteMany({ids:val}, setSelected) }
        handlePageChange={handlePageChange}
      // channelInput = {channelInput}
      />


    </>
  )
}

